import type { FiltersTracking } from './interfaces';

export const generateFiltersTracking = (
  tracking: Partial<FiltersTracking>,
): FiltersTracking => ({
  event: 'interaction_filter_usage',
  e_category: 'navigation',
  e_action: 'Filter results',
  e_label: tracking.e_label,
  amp_event_name: 'Filter results',
  filter_id: tracking.filter_id,
  filter_name: tracking.filter_name,
  filter_value: tracking.filter_value,
  filter_value_min: tracking.filter_value_min,
  filter_value_max: tracking.filter_value_max,
  filter_position: tracking.filter_position,
  filter_count: tracking.filter_count,
  interaction_hit: 'False',
  is_highlighted: tracking.is_highlighted,
  is_quick_filter: !!tracking.is_quick_filter,
  category_id: tracking.category_id,
  category_level: tracking.category_level,
  family_id: tracking.family_id,
});

export const trackResetFilters = (tracking: Partial<FiltersTracking>) => ({
  event: 'interaction_filter_usage',
  e_category: 'navigation',
  e_action: 'Filter results',
  e_label: undefined,
  amp_event_name: 'Filter results',
  filter_id: undefined,
  filter_name: 'Reinitialize filters',
  filter_value: undefined,
  filter_value_min: null,
  filter_value_max: null,
  filter_position: undefined,
  filter_count: undefined,
  category_id: tracking.category_id,
  category_level: tracking.category_level,
  family_id: tracking.family_id,
});

export const interactionFilterSearchBar = (
  tracking: Partial<FiltersTracking>,
) => ({
  event: 'interaction_click on filter search bar',
  event_trigger: `${tracking.filter_name} search bar`,
  amp_event_name: 'Click on filter search bar',
  page_type: tracking.page_type,
});
